import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04ac4010"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-relative" }
const _hoisted_2 = ["required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      class: "form-control",
      style: {"padding-inline-end":"23px"},
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event)),
      required: _ctx.required
    }, null, 8, _hoisted_2), [
      [_vModelText, _ctx.theModel]
    ]),
    _withDirectives(_createElementVNode("span", {
      class: "icon-f icon-recycle clear-input fs-18",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearinput()))
    }, null, 512), [
      [_vShow, _ctx.theModel && _ctx.theModel.length > 0]
    ])
  ]))
}